import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Container } from '@mui/material';
import RecommendationList from '../../list/recommendationList';
import RecommendationsEngine from '../recommendationsEngine';
import CallToActionCard from '../../cards/callToActionCard';
import { useFeatureToggle, useVariables } from '../../../hooks';
import Referral from '../referral';
import { PipelineSwitcher } from '../../common';
import { anonymizeStorage, domain } from '../../../utils/variables';
import { getLocalStorage } from '../../../storage/localStorage';
// import Feedback from '../feedback';
// import QuickLinks from '../quickLinks';
// import ContactUs from '../contactUs';

const MarketingAds = ({ surveySlug }) => {
  const doFeatureToggle = useFeatureToggle();
  const userEmail = useSelector(state => state?.auth?.user?.email);
  const authId = useSelector(state => state?.auth?.user?.id);
  const variables = useVariables();
  const autoPayTestClients = variables?.autoPayTestClients || [];
  const autoPayFeatureActive =
    doFeatureToggle('autoPay') &&
    (autoPayTestClients?.length === 0 ||
      autoPayTestClients?.findIndex(x => x?.toLowerCase() === userEmail?.toLowerCase()) >
        -1);
  const payAnythingFeatureActive = doFeatureToggle(`payAnything`);
  const enableUseOldPipelineData = doFeatureToggle(`enableUseOldPipelineData`);
  const promotions = variables?.promotions || [];
  // const isReferCustomerActive = doFeatureToggle('referACustomer');
  return (
    <Grid container direction="row" spacing={2}>
      {/* isAuthenticated && (
        <Grid item xs={12}>
          <RecommendationsEngine />
        </Grid>
      ) */}
      {/* {isAuthenticated && (
          <Grid item xs={12}>
            <RecommendationList />
          </Grid>
        )} */}
      {/* <Grid item xs={12}>
        <ContactUs />
      </Grid> */}
      {/* <Grid item xs={12}>
        <QuickLinks />
      </Grid> */}
      {enableUseOldPipelineData && domain?.env !== 'production' && (
        <Grid item xs={12}>
          <PipelineSwitcher />
        </Grid>
      )}
      {promotions?.map(promotion => {
        if (promotion.hidden) return null;
        if (promotion?.title?.includes('Recurring') && !autoPayFeatureActive) return null;
        if (promotion?.title?.includes('Custom Pay') && !payAnythingFeatureActive)
          return null;

        const anonymizeUserId = getLocalStorage(anonymizeStorage);
        if (anonymizeUserId && promotion?.title?.includes('Private Wealth Account')) {
          return null;
        }
        if (promotion.type === 'customer-referral') {
          return (
            <Grid item xs={12}>
              <Referral {...promotion} />
            </Grid>
          );
        }
        return (
          <Grid item xs={12} key={promotion?.title}>
            <CallToActionCard {...promotion} />
          </Grid>
        );
      })}

      {/* <Grid item xs={12}>
        <Feedback eventSlug={surveySlug} authRequired />
      </Grid> */}
    </Grid>
  );
};

export default MarketingAds;
